import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes
import { useEffect, createContext, useState } from 'react';
import { DateTime } from 'luxon';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';

// import VConsole from 'vconsole';
// const vConsole = new VConsole({ theme: 'dark' });


// ----------------------------------------------------------------------

export const isLocalhost = Boolean(window.location.hostname === 'localhost' ||
// [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' ||
// 127.0.0.0/8 are considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) 
|| window.location.hostname.includes('ngrok')
);


export const validatedDateTime = (dateTime) => {
  if (dateTime instanceof DateTime) {
    console.log('is DateTime');
    return DateTime;
  }
  if (dateTime instanceof Date) {
    console.log('is Date');
    return DateTime.fromJSDate(dateTime);
  }
  return DateTime.fromJSDate(dateTime).isValid
    ? DateTime.fromJSDate(dateTime)
    : DateTime.fromISO(dateTime).isValid
      ? DateTime.fromISO(dateTime)
      : DateTime.fromJSDate(dateTime).isValid
        ? DateTime.fromJSDate(dateTime)
        // : DateTime.fromJSDate(dateTime.toDate()).isValid
        // ? DateTime.fromJSDate(dateTime.toDate())
        : DateTime.fromMillis(dateTime.toMillis()).isValid
          ? DateTime.fromMillis(dateTime.toMillis())
          : JSON.stringify(dateTime);
};

export const rankNameUnitaliasFrom = (props) => {
  const { rank, name, surname, unit, displayName } = props
  if (!surname) return displayName;
  const surnameAlias = surname.match(/[\u0E01-\u0E2Ea-zA-Z']/)
  return [[rank && rank.includes("หญิง") ? `${rank} ` : rank, name].join(""), `${surnameAlias}.`, unit ? `| ${unit.abbr || unit}` : ""].join(" ").trim()
}

export const maxCapacity = 30
export const capacity = 20
export const AppContext = createContext(null);



const queryParams = new URLSearchParams(window.location.search)
const  hours = queryParams.get("hours")

export const consideredDensityHours = hours || 2
export const NGROK_REDIRECT_URL = 'https://e83c-122-155-138-34.ngrok-free.app'
export const generateRandomString = (length) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  
    for (let i = 0; i < length; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };


export const groupArrayBy = (xs, key) => xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
  
export const statParams = {
  rank: {
    name: 'ชั้นยศ',
    field: 'rank',
    charttype: 'treemap',
    data: {},
    // grid: {md: 8, lg: 6},
    grid: {md: 12, lg: 12}
  },
  type: {
    name: 'ประเภทกำลังพล',
    field: 'type',
    data: {},
    // grid: {md: 8, lg: 6},
    grid: {md: 12, lg: 12}
  },
  unit: {
    name: 'หน่วยที่สังกัด',
    field: 'unit',
    // label: 'abbr',
    charttype: 'treemap',
    data: {},
    // grid: {md: 8, lg: 6},
    grid: {md: 12, lg: 12}
  },

}


export default function App() {

  const [user, setUser] = useState({});


  useEffect(() => {
    
    let mouseTimer = null
    let cursorVisible = true

    function disappearCursor() {
        mouseTimer = null;
        document.body.style.cursor = "none";
        cursorVisible = false;
    }

    document.onmousemove = () => {
      if (mouseTimer) {
        window.clearTimeout(mouseTimer);
      }
      if (!cursorVisible) {
        document.body.style.cursor = "default";
        cursorVisible = true;
      }
      mouseTimer = window.setTimeout(disappearCursor, 1000);
    };
    

  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
        <AppContext.Provider value={{ user, setUser }}>
          
          <ScrollToTop />
          {/* <StyledChart /> */}
          <Router /></AppContext.Provider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
